import { render } from "./BranchDetail.vue?vue&type=template&id=14279b0a"
import script from "./BranchDetail.vue?vue&type=script&lang=js"
export * from "./BranchDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__